import { Button } from '@chakra-ui/react';
import { useState, type FormEvent } from 'react';
import { useKFlags } from '@/hooks/use-k-flags';

import { useAuth } from '@/hooks';
import { Microsoft } from '@/assets/icons/mailbox';

export const MicrosoftLogin = () => {
  const [csrfToken, setCsrfToken] = useState('');
  const { fetchLogin } = useAuth();

  const onSubmitMsLogin = async (event: FormEvent<HTMLFormElement>) => {
    const form = event.target as HTMLFormElement;

    // proceed with normal submit if CSRF token is already there
    const tokenInput = form.elements.namedItem(
      'authenticity_token'
    ) as HTMLInputElement | null;
    if (tokenInput?.value) return;

    // otherwise, fetch the CSRF token, attach it to the form, then submit
    event.preventDefault();
    const newToken = (await fetchLogin())?.data?.csrf_token;
    if (newToken) {
      setCsrfToken(newToken);
      setTimeout(() => form.submit(), 500);
    }
  };

  const { tFeGoogleIncrementalScopes } = useKFlags();

  const msOauthParams = new URLSearchParams({
    for: 'signin',
    origin: window.location.href,
  });

  if (!tFeGoogleIncrementalScopes) {
    msOauthParams.delete('for'); // revert to old behaviour
  }

  return (
    <form
      method="post"
      action={`/api/v1/auth/microsoft_graph?${msOauthParams}`}
      onSubmit={onSubmitMsLogin}
    >
      <input type="hidden" name="authenticity_token" value={csrfToken} />
      <Button
        type="submit"
        variant="quaternary"
        height="40px"
        leftIcon={<Microsoft />}
        width="full"
        data-test-id="sign-in-via-microsoft"
      >
        Sign in with Microsoft
      </Button>
    </form>
  );
};
